<template>

    <v-layout row justify-start>

        <v-flex data-testid="doklink" class="clickable" @click="getDoc()">

            <v-icon color="primary"> file_copy </v-icon>

            <span class="doc-title"> {{ dokName }}</span>

        </v-flex>

    </v-layout>

</template>

<script>
import biztDokService from '../../services/BiztDokService';

export default {
    name: 'BnDokLink',
    props: {
        dokId: {
            required: true,
        },
        dokName: {
            type: String,
            required: true,
        },
    },
    methods: {
        getDoc() {
            biztDokService.getDocById(this.dokId);
        },
    },
};
</script>

<style scoped>
    .clickable{
        cursor: pointer;
    }
</style>
